/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ScanFrameActionCheckIcon16Light } from './ScanFrameActionCheckIcon16Light';
import { ScanFrameActionCheckIcon16Regular } from './ScanFrameActionCheckIcon16Regular';
import { ScanFrameActionCheckIcon16Solid } from './ScanFrameActionCheckIcon16Solid';
import { ScanFrameActionCheckIcon20Light } from './ScanFrameActionCheckIcon20Light';
import { ScanFrameActionCheckIcon20Regular } from './ScanFrameActionCheckIcon20Regular';
import { ScanFrameActionCheckIcon20Solid } from './ScanFrameActionCheckIcon20Solid';
import { ScanFrameActionCheckIcon24Regular } from './ScanFrameActionCheckIcon24Regular';
import { ScanFrameActionCheckIcon24Solid } from './ScanFrameActionCheckIcon24Solid';
import { ScanFrameActionCheckIcon32Regular } from './ScanFrameActionCheckIcon32Regular';
import { ScanFrameActionCheckIcon64Regular } from './ScanFrameActionCheckIcon64Regular';
var sizes = {
    16: {
        light: ScanFrameActionCheckIcon16Light,
        regular: ScanFrameActionCheckIcon16Regular,
        solid: ScanFrameActionCheckIcon16Solid,
    },
    20: {
        light: ScanFrameActionCheckIcon20Light,
        regular: ScanFrameActionCheckIcon20Regular,
        solid: ScanFrameActionCheckIcon20Solid,
    },
    24: {
        regular: ScanFrameActionCheckIcon24Regular,
        solid: ScanFrameActionCheckIcon24Solid,
    },
    32: {
        regular: ScanFrameActionCheckIcon32Regular,
    },
    64: {
        regular: ScanFrameActionCheckIcon64Regular,
    },
};
export var ScanFrameActionCheckIcon = forwardRef('ScanFrameActionCheckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
